import imgVideo from '../Assets/video.svg';
export default [imgVideo];